"use client";

import React from "react";
import Image from "next/image";

export default function MilesoneNew() {
  return (
    <div className="w-full relative isolate overflow-hidden">
      <div
        className="hidden absolute inset-0 -z-10 pointer-events-none select-none md:block"
        style={{ contain: "layout style paint" }}
      >
        <Image
          src="https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/milesOneBGdesktop.webp"
          alt="Miles One Desktop Background"
          fill
          className=""
          sizes="(min-width: 769px) 100vw, 0px"
          loading="lazy"
          quality={90}
        />
      </div>

      <div
        className="absolute inset-0 -z-10 pointer-events-none select-none md:hidden"
        style={{ contain: "layout style paint" }}
      >
        <Image
          src="https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/milesOneBgMobile.webp"
          alt="Miles One Mobile Background"
          fill
          sizes="(max-width: 767px) 480px, 0px"
          loading="lazy"
          quality={85}
        />
      </div>

      <div className="main_container pl-4 pr-0 md:px-8">
        <div className="flex items-center gap-0">
          <div className="flex-1 flex flex-col items-start text-left py-7 md:py-12">
            <p className="text-base font-normal text-white m-0 leading-[1.4] md:text-2xl">
              Download the
            </p>
            <h2 className="text-[30px] font-bold text-white tracking-[-0.025em] leading-[1.1] mt-1 md:text-[51px] md:mt-1.5">
              Miles One App
            </h2>
            <p className="text-xs font-bold text-white mt-2 md:text-2xl md:mt-2.5">
              Start your AI in Accounting Journey today
            </p>

            <div className="flex flex-col gap-3 justify-start items-center mt-5 md:flex-row md:mt-8 md:gap-4">
              <div className="px-4 pl-2.5 py-2 flex items-center gap-2 rounded-lg bg-white/10 cursor-default no-underline text-inherit hover:bg-[#3d3d3d] focus:outline-none">
                <Image
                  src="https://ik.imagekit.io/mileseducation/miles_website/home/app-store.webp"
                  alt="App Store"
                  width={32}
                  height={32}
                  loading="lazy"
                  className="shrink-0 w-7 h-7 md:w-8 md:h-8"
                />
                <div>
                  <p className="text-[9px] leading-[1.2] text-white font-normal m-0 md:text-[10px]">
                    Download on
                  </p>
                  <p className="text-[13px] font-semibold text-white m-0 leading-[1.2] md:text-[15px]">
                    App Store
                  </p>
                </div>
              </div>

              <div className="px-4 pl-2.5 py-2 flex items-center gap-2 rounded-lg bg-white/10 cursor-default no-underline text-inherit hover:bg-[#3d3d3d] focus:outline-none">
                <Image
                  src="https://ik.imagekit.io/mileseducation/miles_website/home/play-store.webp"
                  alt="Play Store"
                  width={32}
                  height={32}
                  loading="lazy"
                  className="shrink-0 w-7 h-7 md:w-8 md:h-8"
                />
                <div>
                  <p className="text-[9px] leading-[1.2] text-white font-normal m-0 md:text-[10px]">
                    Download on
                  </p>
                  <p className="text-[13px] font-semibold text-white m-0 leading-[1.2] md:text-[15px]">
                    Play Store
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="shrink-0 flex items-end justify-end">
            <img
              className="hidden h-auto max-h-[420px] w-auto object-contain md:block"
              src="https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/milesOneBanner.webp"
              alt="Miles One App Preview"
              loading="lazy"
              decoding="async"
            />
            <img
              className="block h-auto max-h-[260px] w-[170px] object-contain md:hidden"
              src="https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cpa-new/milesOnebannerMobile.webp"
              alt="Miles One App Preview"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
